import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

export default {
  /**
   * Obtiene estadísticas de almacenamiento para un rango de fechas
   * @param {Date} startDate - Fecha de inicio
   * @param {Date} endDate - Fecha de fin
   * @returns {Promise} Datos de almacenamiento
   */
  async getStorageStats (startDate, endDate) {
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return { year, month, day }
    }

    const start = formatDate(startDate)
    const end = formatDate(endDate)

    const url = `${API_BASE}/access_no_code/get_size/${start.year}/${start.month}/${start.day}/${end.year}/${end.month}/${end.day}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching storage stats:', error)
      throw error
    }
  },

  /**
   * Obtiene almacenamiento del mes actual
   * @returns {Promise} Datos de almacenamiento
   */
  async getCurrentMonthStorage () {
    const today = new Date()
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    return this.getStorageStats(firstDayOfMonth, today)
  },

  /**
   * Obtiene almacenamiento del último mes
   * @returns {Promise} Datos de almacenamiento
   */
  async getLastMonthStorage () {
    const today = new Date()
    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
    return this.getStorageStats(oneMonthAgo, today)
  },

  /**
   * Crea una nueva solicitud de almacenamiento
   * @param {string} packageName - Nombre del paquete
   * @param {number} requestedStorageBytes - Bytes solicitados
   * @param {string} reason - Razón de la solicitud (opcional)
   * @returns {Promise} Datos de la solicitud creada
   */
  async createStorageRequest (packageName, requestedStorageBytes, reason = '') {
    const url = `${API_BASE}/storage_request/create/`

    try {
      const response = await axios.post(url, {
        package_name: packageName,
        requested_storage_bytes: requestedStorageBytes,
        reason
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error creating storage request:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de solicitudes de almacenamiento
   * @returns {Promise} Lista de solicitudes
   */
  async listStorageRequests () {
    const url = `${API_BASE}/storage_request/list/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error listing storage requests:', error)
      throw error
    }
  },

  /**
   * Obtiene detalle de una solicitud específica
   * @param {string} requestId - ID de la solicitud
   * @returns {Promise} Detalle de la solicitud
   */
  async getStorageRequest (requestId) {
    const url = `${API_BASE}/storage_request/${requestId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching storage request:', error)
      throw error
    }
  }
}
